import { ReactElement, useState } from 'react'
import styled from 'styled-components'

import { IRoutingProjectDatasetLocation } from 'features/RoutingProjects/types'
import { coordinatesToString } from 'utils/map'
import { CoordinatesForm } from 'features/RoutingProjects/components/LocationDetails/CoordinatesForm'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const LocationLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #28265d;
`

const LocationCoordinates = styled.div`
  color: #717171;
  font-size: 12px;
  font-weight: 400;
  line-height: 130%;
`

interface ILocationDetailsProps {
  location: IRoutingProjectDatasetLocation
  isEditable?: boolean
  onCoordinatesUpdate?: (coordinates: { latitude: number; longitude: number }) => void
}

export const LocationDetails = ({
  location,
  isEditable = false,
  onCoordinatesUpdate
}: ILocationDetailsProps): ReactElement => {
  const [isEditing, setIsEditing] = useState<boolean>(false)

  const handleCoordinatesDoubleClick = (): void => {
    if (!isEditable) return

    setIsEditing(true)
  }

  const handleCoordinatesClickAway = (): void => {
    setIsEditing(false)
  }

  const handleCoordinatesSubmit = (coordinates: { latitude: number; longitude: number }): void => {
    onCoordinatesUpdate?.(coordinates)

    setIsEditing(false)
  }

  return (
    <Container>
      <LocationLabel>{location.label}</LocationLabel>
      {isEditing ? (
        <CoordinatesForm
          coordinates={location.coordinates}
          onClickAway={handleCoordinatesClickAway}
          onSubmit={handleCoordinatesSubmit}
        />
      ) : (
        <LocationCoordinates onDoubleClick={handleCoordinatesDoubleClick}>
          {coordinatesToString(location.coordinates)}
        </LocationCoordinates>
      )}
    </Container>
  )
}
